// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"510b9c92","263":"3c5205f3","453":"065e069a","455":"41651396","644":"e71f2efa"}[chunkId] + ".chunk.js";
};